import { Component, Fragment } from 'react';
import Spinner from '~/js/components/Spinner';
import GoFetch from '~/js/modules/fetch-wrapper';
import RoomsSuitesItem from '~/js/views/resorts/components/palm-suites/RoomsSuitesItem';

const fetch = new GoFetch();
const { palmSuitesRooms = [], urisData = {} } = window.sandals_app.page;

class PalmSuites extends Component {
    state = {
        roomsData: [],
        viewMode: 'grid'
    }

    componentDidMount() {
        this.getData();
    }

    getData = () => {
        const data = {
            resortCode: 'SMB'
        };

        fetch.post('/loadRoomData/', null, data)
            .then((response) => {
                const { rooms } = response.data;
                const filtredRooms = rooms.filter((el) => {
                    return palmSuitesRooms.includes(el.roomCategoryCode);
                });

                this.setState({ roomsData: filtredRooms });
            });
    }

    featuresHandler = (e, roomIndex, featureIndex) => {
        const target = e.currentTarget;
        const parentWidth = target.parentNode.offsetWidth;
        const parentHeight = target.parentNode.offsetHeight;
        const popoverState = {
            roomIndex: roomIndex,
            featureIndex: featureIndex,
            bottomPos: parentHeight - target.offsetTop - target.offsetHeight,
            arrowLeft: `${target.offsetLeft / parentWidth * 100}%`,
        };

        this.setState({ popover: popoverState });
    };

    render() {
        const { roomsData, popover, viewMode } = this.state;
        const viewModeHandler = (mode) => {
            // it's not a good solution, but I don't know how refresh React Slick
            const setStateCallback = () => {
                if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
                    const evt = document.createEvent('UIEvents');

                    evt.initUIEvent('resize', true, false, window, 0);
                    window.dispatchEvent(evt);
                } else {
                    window.dispatchEvent(new Event('resize'));
                }
            };

            this.setState({ viewMode: mode }, setStateCallback);
        };

        let roomsList = <Spinner />;

        if (roomsData) {
            if (roomsData.length) {
                roomsList = (
                    <div className="rooms-list">
                        {roomsData.map((el, index) => {
                            const detailsLink = urisData[`${el.rstCode.toLowerCase()}_rooms_and_suites_details`] + `?categoryCode=${el.roomCategoryCode}`;

                            const closeHandler = (e) => {
                                e.stopPropagation();
                                this.setState({ popover: null });
                            };

                            const props = {
                                key: index,
                                roomIndex: index,
                                type: viewMode,
                                rstCode: el.rstCode.toLowerCase(),
                                images: el.additionalImageCodes.split(','),
                                name: el.roomCategoryName,
                                description: el.roomDescription,
                                roomView: el.roomCategoryView,
                                features: el.features,
                                rate: el.rate.avgRate,
                                promotions: el.promotions,
                                detailsLink: detailsLink,
                                popoverState: popover,
                                openPopoverHandler: this.featuresHandler,
                                closePopoverHandler: closeHandler
                            };

                            return <RoomsSuitesItem { ...props } />;
                        })}
                    </div>
                );
            }
        } else {
            roomsList = <div className="no-result">There are no palm rooms and suites</div>;
        }

        return (
            <Fragment>
                <div className="rooms-head">
                    <h3 className="rooms-title"><span>Accommodations</span> At The Beachfront Palm Suites</h3>
                    <div className="view-controls">
                        <button
                            className={`view-btn ${viewMode === 'grid' ? 'active' : ''}`}
                            onClick={() => viewModeHandler('grid')}>
                            <i className="ic ic-grid-view" />
                            Grid View
                        </button>
                        <button
                            className={`view-btn ${viewMode === 'list' ? 'active' : ''}`}
                            onClick={() => viewModeHandler('list')}>
                            <i className="ic ic-list-view" />
                            List View
                        </button>
                    </div>
                </div>

                {roomsList}
            </Fragment>
        );
    }
}

export default PalmSuites;
